import { render, staticRenderFns } from "./presentacion-mapa.vue?vue&type=template&id=55c00549&scoped=true&"
import script from "./presentacion-mapa.vue?vue&type=script&lang=js&"
export * from "./presentacion-mapa.vue?vue&type=script&lang=js&"
import style0 from "./presentacion-mapa.vue?vue&type=style&index=0&id=55c00549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c00549",
  null
  
)

export default component.exports